<template>
  <div class="kpi-column-board">
    <div class="kpi-columns">
      <KpiColumn  v-for="column in columns"
                  :key="column.id"
                  :column="column"
                  @toggle-column-expanded="handleToggleColumnExpanded" />
    </div>
  </div>
</template>

<script>
import KpiColumn from './KpiColumn.vue';

export default {
  name: 'KpiColumnBoard',

  emits: ['toggle-column-expanded'],

  components: {
    KpiColumn
  },

  props: {
    columns:  { type: Array,      required: true },
    id:       { type: String,     required: true }
  },

  methods: {
    handleToggleColumnExpanded(event) {
      this.$emit('toggle-column-expanded', { controlId: this.id, columnId: event.columnId });
    }
  }
};
</script>

<style lang="scss" scoped>
.kpi-column-board {
  // width: 100%;
  overflow-x: auto;
}

.kpi-columns {
  display: flex;
  gap: 1.5rem;
  overflow-x: auto;
  padding-bottom: 1rem;

  // Horizontale Scrollbar Styling
  &::-webkit-scrollbar {
    height: 8px; // Höhe der horizontalen Scrollbar
  }

  &::-webkit-scrollbar-track {
    background: var(--bs-secondary-bg);
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background: var(--bs-gray-400);
    border-radius: 4px;

    &:hover {
      background: var(--bs-gray-500);
    }
  }

  &::-webkit-scrollbar-thumb:active {
    background: var(--bs-gray-600);
  }
}
</style>
